import { acceptTosVersion } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const AcceptTosVersion = async (groupId, tosVersion, accessToken) => {

    try {
        const response = await acceptTosVersion(groupId, tosVersion, accessToken);
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, data: extractApiErrorMessage(error) };
    }
};

export default AcceptTosVersion;
